import { Injectable, inject } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { UserService } from '../services/user/user.service';
import { USER_TOKEN } from '../authentication/user-token.util';
import { SeqLogService } from '../services/seq/seq-log.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly token = inject(USER_TOKEN);
  #userService = inject(UserService);
  #seq = inject(SeqLogService);

  constructor() { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Don't intercept SEQ log calls themselves
    if (request.url === environment.seqUrl) {
      return next.handle(request);
    }

    return next.handle(request).pipe(catchError(err => {
      if ([401, 403].includes(err.status) && this.token) {
        // auto logout if 401 or 403 response returned from our apis, ignore from
        // digifabster and Box — a Box token or whitelisting problem must not
        // log the user out mid-upload
        if (!err.url?.includes('digifabster') && !this.isBoxRequest(request.url)) {
          this.#userService.loginRedirect();
        } else {
          console.log(`Logging out after error received from ${err.url}`);
        }
      }

      console.error(err);

      // Sanitize headers — strip Authorization to avoid logging tokens
      const headers: Record<string, string> = {};
      request.headers.keys().forEach(key => {
        if (key.toLowerCase() !== 'authorization') {
          headers[key] = request.headers.get(key) ?? '';
        }
      });

      const user = this.token?.value?.user_name ?? this.token?.value?.QPUser ?? undefined;
      this.#seq.logHttpError(err, request.method, request.url, request.body, headers, user);

      const error = err;
      return throwError(() => error);
    }))
  }

  // Box itself (upload.box.com / api.box.com) or the ITO MS box/* endpoints
  private isBoxRequest(url: string): boolean {
    return /^https:\/\/[^/]*\.box\.com\//.test(url) || url.startsWith(`${environment.itoMSUrl}box/`);
  }
}
